module.exports = __webpack_public_path__ + "img/prize2.740cee17.jpg";